import GraphQLError from 'graphql'

// Determines if the GraphQL errors indicate that the user is not authenticated
// for the specified query
export const hasUnauthenticatedError = (errors: ReadonlyArray<GraphQLError> = []) =>
  Boolean(
    errors.find(
      ({ name, message }) =>
        name === 'NotAuthorized' ||
        name === 'NotAuthorizedError' ||
        name === 'MissingTokenError' ||
        message === 'You do not have permission to access this resource.' ||
        message.match(/not_authorized/),
    ),
  )

// Determines if the GraphQL errors indicate that the service is unavailable
export const hasServiceUnavailableError = (errors: ReadonlyArray<GraphQLError> = []) =>
  Boolean(errors.find(({ code }) => code === 'service_unavailable'))
